export { ColourCodes, grupIndex, GrupColourCodes, GrupNames, ANGKATAN_PERTAMA, SELF_ENTRY_INDEX_THRESHOLD, EVENT_ID_SLA2026 } from './constants-sla.js';
export var Gender;
(function (Gender) {
    Gender["LakiLaki"] = "M";
    Gender["Perempuan"] = "F";
})(Gender || (Gender = {}));
export var Religion;
(function (Religion) {
    Religion["ISLAM"] = "I";
    Religion["KRISTEN"] = "K";
    Religion["HINDU"] = "H";
    Religion["BUDHA"] = "B";
    Religion["KONGHUCU"] = "C";
    Religion["LAINNYA"] = "-";
})(Religion || (Religion = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["Active"] = 0] = "Active";
    UserStatus[UserStatus["Deactivated"] = 1] = "Deactivated";
})(UserStatus || (UserStatus = {}));
;
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus[RegistrationStatus["Pending"] = 0] = "Pending";
    RegistrationStatus[RegistrationStatus["Approved"] = 1] = "Approved";
    RegistrationStatus[RegistrationStatus["Rejected"] = 2] = "Rejected";
})(RegistrationStatus || (RegistrationStatus = {}));
;
export const Roles = {
    SUPER_SUPER: 3030,
    ADMIN_ALL: 12323,
    ADMIN_ANGKATAN: 12123,
    PANITIA_PINDAI: 10031,
    PANITIA_ABSENSI: 10032,
    VIEW_CHART: 13323,
};
export var PrivacyVisibility;
(function (PrivacyVisibility) {
    PrivacyVisibility["Admin"] = "0";
    PrivacyVisibility["Angkatan"] = "1";
    PrivacyVisibility["Public"] = "2";
})(PrivacyVisibility || (PrivacyVisibility = {}));
export var PrivacyField;
(function (PrivacyField) {
    PrivacyField[PrivacyField["None"] = 0] = "None";
    PrivacyField[PrivacyField["Phone"] = 1] = "Phone";
    PrivacyField[PrivacyField["Address"] = 2] = "Address";
    PrivacyField[PrivacyField["Email"] = 3] = "Email";
    PrivacyField[PrivacyField["Job"] = 4] = "Job";
    PrivacyField[PrivacyField["Birthday"] = 5] = "Birthday";
    PrivacyField[PrivacyField["Relation"] = 6] = "Relation";
    PrivacyField[PrivacyField["Academic"] = 7] = "Academic";
})(PrivacyField || (PrivacyField = {}));
export function getVisibility(privacies, privacy) {
    if (privacy == PrivacyField.None)
        return PrivacyVisibility.Admin;
    else
        return privacies?.charAt(privacy - 1);
}
export function setVisibility(privacies, privacy, visibility) {
    return privacies?.substring(0, privacy - 1) + visibility + privacies?.substring(privacy);
}
export const HIDDEN_STRING = "##HIDDEN##";
export const HIDDEN_DATE = "1911-12-13T14:15:16.170Z";
export var ConfirmationStatus;
(function (ConfirmationStatus) {
    ConfirmationStatus[ConfirmationStatus["Unknown"] = 0] = "Unknown";
    ConfirmationStatus[ConfirmationStatus["Hadir"] = 1] = "Hadir";
    ConfirmationStatus[ConfirmationStatus["MungkinHadir"] = 2] = "MungkinHadir";
    ConfirmationStatus[ConfirmationStatus["TidakHadir"] = 3] = "TidakHadir";
})(ConfirmationStatus || (ConfirmationStatus = {}));
export var VerificationMode;
(function (VerificationMode) {
    VerificationMode[VerificationMode["Unknown"] = 0] = "Unknown";
    VerificationMode[VerificationMode["QR"] = 1] = "QR";
    VerificationMode[VerificationMode["Manual"] = 2] = "Manual";
})(VerificationMode || (VerificationMode = {}));
export var QrStatus;
(function (QrStatus) {
    QrStatus[QrStatus["Pending"] = 0] = "Pending";
    QrStatus[QrStatus["Verified"] = 1] = "Verified";
    QrStatus[QrStatus["Expired"] = 2] = "Expired";
})(QrStatus || (QrStatus = {}));
export var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["CodeVerified"] = 91] = "CodeVerified";
    ResponseCode[ResponseCode["EventNotMatch"] = 92] = "EventNotMatch";
    ResponseCode[ResponseCode["InvalidData"] = 93] = "InvalidData";
    ResponseCode[ResponseCode["CodeExpired"] = 94] = "CodeExpired";
    ResponseCode[ResponseCode["AlreadyAttend"] = 95] = "AlreadyAttend";
    ResponseCode[ResponseCode["RandomNotMatch"] = 96] = "RandomNotMatch";
    ResponseCode[ResponseCode["MemberNotMatch"] = 97] = "MemberNotMatch";
    ResponseCode[ResponseCode["RecordNotFound"] = 98] = "RecordNotFound";
    ResponseCode[ResponseCode["Unknown"] = 99] = "Unknown";
})(ResponseCode || (ResponseCode = {}));
;
